var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader d-flex justify-center align-center"},[_c('v-progress-circular',{attrs:{"size":50,"color":_vm.color,"indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }